import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { EN, JP } from '../languages';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ja: {
        translations: JP,
      },
      en: {
        translations: EN,
      },
    },
    fallbackLng: 'ja',
    lng: 'ja',
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'app-language',
    },
  });

export default i18n;
